import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, MessageSquare, ShoppingBag, LogOut, MailWarning, Quote } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import Seo from "./Seo";

const TABS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Inventory", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/recovery", label: "Recovery", icon: MailWarning },
  { to: "/admin/testimonials", label: "Reviews", icon: Quote },
  { to: "/admin/enquiries", label: "Enquiries", icon: MessageSquare },
];

export default function AdminLayout({ children, eyebrow = "Elegant Affairs · Manage", title, action = null }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    toast.success("Signed out.");
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="pt-32 pb-24" data-testid="admin-layout">
      <Seo title="Manage" noindex />
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-10 gap-6 flex-wrap">
          <div>
            <p className="eyebrow">{eyebrow}</p>
            <h1 className="font-display text-5xl md:text-7xl mt-3 tracking-tighter" data-testid="admin-title">
              {title}
            </h1>
          </div>
          <div className="flex items-center gap-3">
            {action}
            <button
              onClick={onLogout}
              className="btn-ghost !px-5 !py-3"
              data-testid="admin-logout"
              aria-label="Sign out"
            >
              <LogOut size={14} strokeWidth={1.5} /> Sign out
            </button>
          </div>
        </div>

        <nav className="border-y border-[var(--mn-border)] mb-12" data-testid="admin-subnav">
          <ul className="flex gap-8 overflow-x-auto no-scrollbar">
            {TABS.map((t) => (
              <li key={t.to}>
                <NavLink
                  to={t.to}
                  end={t.end}
                  data-testid={`admin-tab-${t.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `inline-flex items-center gap-2 py-4 text-xs uppercase tracking-[0.22em] border-b-2 transition-colors ${
                      isActive
                        ? "border-[var(--mn-ink)] text-[var(--mn-ink)]"
                        : "border-transparent text-[var(--mn-ink-2)] hover:text-[var(--mn-ink)]"
                    }`
                  }
                >
                  <t.icon size={14} strokeWidth={1.4} /> {t.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {children}
      </div>
    </div>
  );
}
